module.exports = __webpack_public_path__ + "static/venice20896-e56a95f32877d6e85ce79bf8dff807f7.png";